import createWrappedField from './createWrappedField'
import NS from '../NumberSpinner'

export default createWrappedField({
  Component: NS,
  name: 'DDINumberSpinner'
})
